import "./loading.css";
const Loading = () => {
  return (
    <div className="loading d-flex justify-content-center align-items-center container">
      <div className="custom-loader"></div>
    </div>
  );
};

export default Loading;
